import { render } from "./history.vue?vue&type=template&id=0a32e568"
import script from "./history.vue?vue&type=script&lang=js"
export * from "./history.vue?vue&type=script&lang=js"

import "@/assets/css/new.scss?vue&type=style&index=0&lang=scss"
import "./history.vue?vue&type=style&index=1&id=0a32e568&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__